import OrderDetailsPage from "../../features/order-details/order-details-page";

export default function OrderDetails() {
  return <OrderDetailsPage />;
}
